export default __webpack_public_path__ + "static/media/img4.d5a258fc.PNG";